module.exports = __webpack_public_path__ + "img/apple.1243e543.svg";